import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as NotificationActions from '../_actions/notification';
import { Notification } from '../_models';

export interface NotificationState extends EntityState<Notification> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Notification> = createEntityAdapter<Notification>();

const initialState: NotificationState = adapter.getInitialState({
  loading: false,
  error: null,
});

const notificationReducer = createReducer(
  initialState,

  on(NotificationActions.loadNotifications, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(NotificationActions.loadNotificationsSuccess, (state, { notifications }) =>
    adapter.setAll(notifications, { ...state, loading: false })
  ),

  on(NotificationActions.loadNotificationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(NotificationActions.addNotificationSuccess, (state, { notification }) =>
    adapter.addOne(notification, state)
  ),

  on(NotificationActions.updateNotificationSuccess, (state, { notification }) =>
    adapter.upsertOne(notification, state)
  ),

  on(NotificationActions.deleteNotificationSuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    NotificationActions.addNotificationFailure,
    NotificationActions.updateNotificationFailure,
    NotificationActions.deleteNotificationFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: NotificationState | undefined, action: Action) {
  return notificationReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
